import SEO from "./SEO";

const PrivacySEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Privacy Policy",
    description:
      "Privacy Policy for NABAZAT AL QALB. Learn how we collect, use, and protect your personal information.",
    url: "https://nabazatalqalb.com/privacy",
    isPartOf: {
      "@type": "WebSite",
      name: "NABAZAT AL QALB",
      url: "https://nabazatalqalb.com",
    },
  };

  return (
    <SEO
      title="Privacy Policy"
      description="Read the Privacy Policy of NABAZAT AL QALB. Learn how we collect, use, store, and protect your personal information when you visit our website or contact us."
      keywords="privacy policy, NABAZAT AL QALB privacy, data protection, personal information, medical company privacy policy"
      url="https://nabazatalqalb.com/privacy"
      structuredData={structuredData}
    />
  );
};

export default PrivacySEO;
